<!--

@Author Érik
-->

<template>
  <div class="pageAbout">

    <md-app class="viewport">

      <md-app-toolbar class="md-primary navbar" md-elevation="0">
        <navbar/>
      </md-app-toolbar>

      <md-app-content class="allAbout">

        <md-card class="cardAbout">
          <md-card-content>
          <h2>Sobre</h2>

          <p>
            Chapstory é a primeira plataforma de rede social comprometida em integrar
            histórias locais e pessoais de diversas localidades do mundo, conectando pessoas
            que, em algum momento de suas vidas, compartilharam memórias onde os fatos
            ocorreram.
          </p>

          <p>
            Essa rede é um espaço que reúne pessoas de idades e culturas diferentes,
            formação e crenças diversas, estimuladas por um interesse único: contar suas
            histórias e reencontrar amigos antigos. As histórias compartilhadas ficarão
            disponíveis para todos os usuários do aplicativo, não apenas no perfil de uma
            pessoa. Assim, é possível encontrar diversos acontecimentos em um mesmo local,
            mas em épocas e com pessoas diferentes, possibilitando o reencontro das que
            viveram a mesma história contada.
          </p>

          <p>
            Nosso objetivo é trazer à memória lembranças que fazem as pessoas reviverem os
            momentos de suas vidas, bem como fatos históricos e marcantes de onde vivem
            ou viveram algum dia, e que poderão ser compartilhados por seus descendentes e
            amigos.
          </p>

          <h2>Missão</h2>

          <p>
            A partir dos registros de diferentes histórias, proporcionar nostalgia ao relembrar
            acontecimentos e ao reencontrar pessoas, bem como registrar fatos históricos que
            poderão ser usados como fonte de pesquisas para alunos e historiadores.
          </p>

          <h2>Visão</h2>

          <p>
            Possibilitar que as pessoas contem suas histórias e criem suas biografias
            pessoais, além de contribuir para o registro de acontecimentos nos locais onde
            viveram, criando assim um grande documentário de cada cidade.
          </p>

          <h2>Valores</h2>

            <ul>
              <li>Compromisso com a verdade</li>
              <li>Ética, respeito e honestidade</li>
              <li>Sua história é importante para a gente</li>
              <li>Valorização e respeito aos colaboradores</li>
              <li>Melhoria contínua</li>
            </ul>

          <h1 class="aboutUs">Quem somos</h1>

            <ul class="members-ul">
              <li><span class="members-span">Idealizador:</span> Wilson Araújo da Silva</li>
              <li><span class="members-span">DevOps:</span> Alexandre Leão de Figueiredo</li>
              <li><span class="members-span">Programadores:</span> <a :href="'https://www.linkedin.com/in/ccwerner/'" class="textFooter">Christian Costa Werner, </a><a :href="'https://www.linkedin.com/in/erik-brito-8b2b02b6/'" class="textFooter">José Érik Brito Pereira</a></li>
              <li><span class="members-span">Scrum Master:</span> Silvana Pessoa Guerra de Siqueira</li>
            </ul>
          </md-card-content>
        </md-card>

        <div class="divFooter">
          <Footer/>
        </div>

      </md-app-content>

    </md-app>

  </div>
</template>

<script>
import navbar from '../../toolbar/navbar.vue'
import Footer from '../landing/footer.vue'

export default{
  components: {
    navbar,
    Footer
  },
  metaInfo: {
    title: "Sobre nós",
    meta: [
      {name: "robots", content: "index"},
      {name: "keywords", content: "sobre, quem é, o que é"},
      {name: "description", content: "Chapstory é uma rede social comprometida em integrar histórias locais e pessoais de diversas localidades do mundo, conectando pessoas que compartilharam memórias onde os fatos ocorreram."},
      {rel: "canonical", href: "https://www.chapstory.com/about"}
    ]
  }
}

</script>

<style lang="scss" scoped>
.viewport {
  height: 100vh;
  width: 100vw;
}

.md-content{
  background-color: #e4f9f54a;
}

.md-toolbar, .md-toolbar-row, .md-app-toolbar, .md-app-toolbar-row {
  width:100%;
  min-height:50px !important;
  display:flex;
  align-items:center;
  align-content:center;
  transition:.3s cubic-bezier(.4,0,.2,1);
  transition-property:opacity,background-color,box-shadow,transform,color,min-height;
  will-change:opacity,background-color,box-shadow,transform,color,min-height
}

.allAbout{
  overflow-y: auto;
  height: calc(100vh - 50px);
}

.members-ul{
  list-style-type: none;
  padding: 0;
}

.members-span{
  font-weight: bold;
}

.cardAbout{
  position: relative;
  margin: 0 auto;
  width: 80%;
}

.linksAbout{
  position: relative;
  margin: 3em auto 0 auto;
  width: 80%;
}

.links{
  margin: 0 5px;
  font-size: large;
}

.md-app-content {
  padding: 16px 0 0;
}

.md-card-content{
  padding: 16px;
  margin: 26px;
}

.divFooter {
  bottom: 0;
  display: flow-root;
  height: auto;
  background: #40514e;
}
</style>
